export const LEAD_STAGES = [
  { id: 'new', label: 'Prospecto Nuevo', backendValue: 'Nuevo Prospecto' },
  { id: 'contacted', label: 'Llamada Realizada', backendValue: 'Llamada Realizada' },
  { id: 'meeting', label: 'Reunión Agendada', backendValue: 'Reunión Agendada' },
  { id: 'proposal', label: 'Propuesta Presentada', backendValue: 'Propuesta Presentada' },
  { id: 'negotiation', label: 'Negociación / Cierre', backendValue: 'Negociación' },
  { id: 'won', label: 'GANADO', backendValue: 'Ganado' },
  { id: 'lost', label: 'Perdido / Pospuesto', backendValue: 'Perdido' }
];

export const getStageIdByBackendValue = (value) => {
  const stage = LEAD_STAGES.find(s => s.backendValue === value);
  return stage ? stage.id : 'new';
};

export const getBackendValueByStageId = (id) => {
  const stage = LEAD_STAGES.find(s => s.id === id);
  return stage ? stage.backendValue : 'Nuevo Prospecto';
};
